module.exports = __webpack_public_path__ + "fonts/Graphik-MediumItalic.woff2";